import React, { Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Path } from './Paths';
import LoadingIndicator from '../Common/LoadingIndicator';
import styled from 'styled-components';
import NotFound from '../Common/NotFound';
import DefaultLayout from './DefaultLayout';
import KeyboardInstallationGuide from '../KeyboardInstallationGuide';
import AndroidKeyboardInstallationGuide from '../AndroidKeyboardInstallationGuide';
import PartnerpluginsdkActivate from '../PartnerpluginsdkActivate';
import { ScrollToTop } from '../Common/ScrollToTop';
import { SamsungActivation } from '../Samsung';
import ExtensionInstalled from '../Extension/ExtensionInstalled';
import ExtensionUninstalled from '../Extension/ExtensionUninstalled';
import SamsungLanding from '../Samsung/SamsungLanding';
import TreePlanting from '../TreePlanting';
import ChromeDesktopUTMTracking from '../ChromeDesktopUTMTracking/ChromeDesktopUTMTracking';
import PartnerPluginActivateMultiStepAlwaysAllow from '../PartnerpluginsdkActivate/PartnerPluginActivateMultiStepAlwaysAllow';
import PartnerPluginActivateMultiStepAlmostThere from '../PartnerpluginsdkActivate/PartnerPluginActivateMultiStepAlmostThere';
import PartnerPluginActivateMultiStepBeSureToAllow from '../PartnerpluginsdkActivate/PartnerPluginActivateMultiStepBeSureToAllow';
import PartnerPluginActivateMultiStepStartShopping from '../PartnerpluginsdkActivate/PartnerPluginActivateMultiStepStartShopping';
import PartnerNewpluginsdkActivate from '../PartnerNewpluginsdkActivate';
import LinkRedirect from './LinkRedirect';
import PartnerNewPluginActivateMultiStepAlwaysAllow from '../PartnerNewpluginsdkActivate/PartnerNewPluginActivateMultiStepAlwaysAllow';
import PartnerNewPluginActivateMultiStepPartialPermissions from '../PartnerNewpluginsdkActivate/PartnerNewPluginActivateMultiStepPartialPermissions';
import PartnerNewPluginActivateMultiStepAllDone from '../PartnerNewpluginsdkActivate/PartnerNewPluginActivateMultiStepAllDone';
import AndroidAccessibility from '../AndroidAccessibility';
import PartnerPluginActivateV2 from '../PartnerPluginActivateV2';
import OfferWall from '../OfferWall';
import TIMActivationHome from '../TIM';
import EonPluginActivation from '../EonPluginActivation';
import EonPluginActivationAlwaysAllow from '../EonPluginActivation/EonPluginActivationAlwaysAllow';
import EonPluginActivationMultiStep from '../EonPluginActivation/EonPluginActivationMultiStep';
import EonPluginActivationStartShopping from '../EonPluginActivation/EonPluginActivationStartShopping';
import EonPluginActivationPartialPermissions from '../EonPluginActivation/EonPluginActivationPartialPermissions';
import EonPluginActivationAndroidAccessibility from '../EonPluginActivation/EonPluginActivationAndroidAccessibility';
import NTVPluginActivationHome from '../NTVPluginActivation';
import NTVPluginActivateMultiStep from '../NTVPluginActivation/NTVPluginActivationMultiStep';
import NTVPluginActivationAlwaysAllow from '../NTVPluginActivation/NTVPluginActivationAlwaysAllow';
import NTVPluginActivationPartialPermissions from '../NTVPluginActivation/NTVPluginActivationPartialPermissions';
import NTVPluginActivationStartShopping from '../NTVPluginActivation/NTVPluginActivationStartShopping';
import NTVPluginActivationAndroidAccessibility from '../NTVPluginActivation/NTVPluginActivationAndroidAccessibility';
import NTVPluginActivationAlternateBrowser from '../NTVPluginActivation/NTVPluginActivationAlternateBrowser';
import BlueLightCardPluginActivationHome from '../BlueLightCardPluginActivation';
import BlueLightCardPluginActivationMultiStep from '../BlueLightCardPluginActivation/BlueLightCardPluginActivationMultiStep';
import BlueLightCardPluginActivationAlwaysAllow from '../BlueLightCardPluginActivation/BlueLightCardPluginActivationAlwaysAllow';
import BlueLightCardPluginActivationPartialPermissions from '../BlueLightCardPluginActivation/BlueLightCardPluginActivationPartialPermissions';
import BlueLightCardPluginActivationStartShopping from '../BlueLightCardPluginActivation/BlueLightCardPluginActivationStartShopping';
import BlueLightCardPluginActivationAndroidAccessibility from '../BlueLightCardPluginActivation/BlueLightCardPluginActivationAndroidAccessibility';
import TIMAndroidAccessibility from '../TIM/AndroidAccessibility';
import PartnerNewpluginsdkActivateTim from '../PartnerNewpluginsdkActivateTim';
import PartnerNewPluginActivateTimMultiStepAlwaysAllow from '../PartnerNewpluginsdkActivateTim/PartnerNewPluginActivateTimMultiStepAlwaysAllow';
import PartnerNewPluginActivateTimMultiStepPartialPermissions from '../PartnerNewpluginsdkActivateTim/PartnerNewPluginActivateTimMultiStepPartialPermissions';
import PartnerNewPluginActivateTimMultiStepAllDone from '../PartnerNewpluginsdkActivateTim/PartnerNewPluginActivateTimMultiStepAllDone';
import DesktopExtensionLanding from '../ExtensionV2/Landing';
import ExtensionInstalledV2 from '../ExtensionV2/ExtensionInstalled';
import NationalRailExtensionInstalled from '../NationalRailDesktopActivation/ExtensionInstalled';
import NationalRailLanding from '../NationalRailDesktopActivation/Landing';

const StyledLoadingIndicator = styled(LoadingIndicator)`
  min-height: 1500px;
`;

const Routes = () => (
  <Suspense fallback={<StyledLoadingIndicator />}>
    <ScrollToTop />
    <Switch>
      <Route path={Path.KeyboardInstallationGuide} exact>
        <KeyboardInstallationGuide />
      </Route>
      <Route path={Path.AndroidKeyboardInstallationGuide} exact>
        <AndroidKeyboardInstallationGuide />
      </Route>
      <Route path={Path.PluginActivation} exact>
        <PartnerpluginsdkActivate />
      </Route>
      <Route path={Path.PluginActivationV2ActivatePlugin} exact>
        <PartnerNewpluginsdkActivate />
      </Route>
      <Route path={Path.TimPluginActivationActivatePlugin} exact>
        <PartnerNewpluginsdkActivateTim />
      </Route>
      <Route path={Path.TimPluginActivationAlwaysAllow} exact>
        <PartnerNewPluginActivateTimMultiStepAlwaysAllow />
      </Route>
      <Route path={Path.TimPluginActivationPartialPermissions} exact>
        <PartnerNewPluginActivateTimMultiStepPartialPermissions />
      </Route>
      <Route path={Path.TimPluginActivationStartShopping} exact>
        <PartnerNewPluginActivateTimMultiStepAllDone />
      </Route>
      <Route path={Path.TimPluginActivationAndroidStartShopping} exact>
        <PartnerNewPluginActivateTimMultiStepAllDone platform="android" />
      </Route>
      <Route path={Path.EonPluginActivationHome} exact>
        <EonPluginActivation />
      </Route>
      <Route path={Path.EonPluginActivationMultiStep} exact>
        <EonPluginActivationMultiStep />
      </Route>
      <Route path={Path.EonPluginActivationAlwaysAllow} exact>
        <EonPluginActivationAlwaysAllow />
      </Route>
      <Route path={Path.EonPluginActivationStartShopping} exact>
        <EonPluginActivationStartShopping />
      </Route>
      <Route path={Path.EonPluginActivationPartialPermissions} exact>
        <EonPluginActivationPartialPermissions />
      </Route>
      <Route path={Path.EonPluginAndroidAccessibility} exact>
        <EonPluginActivationAndroidAccessibility />
      </Route>
      <Route path={Path.NTVPluginActivationHome} exact>
        <NTVPluginActivationHome />
      </Route>
      <Route path={Path.NTVPluginActivationMultiStep} exact>
        <NTVPluginActivateMultiStep />
      </Route>
      <Route path={Path.NTVPluginActivationAlwaysAllow} exact>
        <NTVPluginActivationAlwaysAllow />
      </Route>
      <Route path={Path.NTVPluginActivationStartShopping} exact>
        <NTVPluginActivationStartShopping />
      </Route>
      <Route path={Path.NTVPluginAndroidAccessibility} exact>
        <NTVPluginActivationAndroidAccessibility />
      </Route>
      <Route path={Path.NTVPluginActivationPartialPermissions} exact>
        <NTVPluginActivationPartialPermissions />
      </Route>
      <Route path={Path.NTVPluginActivationAlternateBrowser} exact>
        <NTVPluginActivationAlternateBrowser />
      </Route>
      <Route path={Path.BlueLightCardPluginActivationHome} exact>
        <BlueLightCardPluginActivationHome />
      </Route>
      <Route path={Path.BlueLightCardPluginActivationMultiStep} exact>
        <BlueLightCardPluginActivationMultiStep />
      </Route>
      <Route path={Path.BlueLightCardPluginActivationAlwaysAllow} exact>
        <BlueLightCardPluginActivationAlwaysAllow />
      </Route>
      <Route path={Path.BlueLightCardPluginActivationStartShopping} exact>
        <BlueLightCardPluginActivationStartShopping />
      </Route>
      <Route path={Path.BlueLightCardPluginAndroidAccessibility} exact>
        <BlueLightCardPluginActivationAndroidAccessibility />
      </Route>
      <Route path={Path.BlueLightCardPluginActivationPartialPermissions} exact>
        <BlueLightCardPluginActivationPartialPermissions />
      </Route>
      <Route path={Path.SamsungLanding} exact>
        <SamsungLanding />
      </Route>
      <Route path={Path.SamsungActivation} exact>
        <SamsungActivation />
      </Route>
      <Route path={Path.TIMActivationHome} exact>
        <TIMActivationHome />
      </Route>
      <Route path={Path.TIMHomePage} exact>
        <TIMActivationHome />
      </Route>
      <Route path={Path.TIMAndroidActivationHome} exact>
        <TIMAndroidAccessibility />
      </Route>
      <Route path={Path.ExtensionInstalled} exact>
        <ExtensionInstalled />
      </Route>
      <Route path={Path.ExtensionUninstalled} exact>
        <ExtensionUninstalled />
      </Route>
      <Route path={Path.DesktopLanding} exact>
        <DesktopExtensionLanding />
      </Route>
      <Route path={Path.ExtensionInstalledV2} exact>
        <ExtensionInstalledV2 />
      </Route>
      <Route path={Path.NationalRailExtensionInstalled} exact>
        <NationalRailExtensionInstalled />
      </Route>
      <Route path={Path.NationalRailLanding} exact>
        <NationalRailLanding />
      </Route>
      <Route path={`${Path.TreePlanting}`}>
        <TreePlanting />
      </Route>

      <Route path={`${Path.EtisalatOfferWall}`} exact>
        <OfferWall />
      </Route>

      <Route path={`${Path.EtisalatOfferWallArabic}`} exact>
        <OfferWall documentDir="rtl" />
      </Route>

      <Route path={`${Path.PluginActivationV2}`} exact>
        <PartnerPluginActivateV2 />
      </Route>

      <Route path={`${Path.PluginActivationReviewPermissionsV2}`} exact>
        <AndroidAccessibility />
      </Route>

      <Route path={Path.PluginActivationReviewPermissions} exact>
        <PartnerPluginActivateMultiStepAlwaysAllow />
      </Route>
      <Route path={Path.PluginActivationV2AlwaysAllow} exact>
        <PartnerNewPluginActivateMultiStepAlwaysAllow />
      </Route>
      <Route path={Path.PluginActivationV2PartialPermissions} exact>
        <PartnerNewPluginActivateMultiStepPartialPermissions />
      </Route>
      <Route path={Path.PluginActivationV2StartShopping} exact>
        <PartnerNewPluginActivateMultiStepAllDone />
      </Route>
      <Route path={Path.PluginActivationAllowPermissions} exact>
        <PartnerPluginActivateMultiStepAlmostThere />
      </Route>
      <Route path={Path.PluginActivationUpdatePermissions} exact>
        <PartnerPluginActivateMultiStepBeSureToAllow />
      </Route>
      <Route path={Path.PluginActivationStartShopping} exact>
        <PartnerPluginActivateMultiStepStartShopping />
      </Route>

      <DefaultLayout>
        <Switch>
          <Route path={Path.Home} exact>
            <LinkRedirect />
          </Route>
          <Route path={Path.UnderTheHood} exact>
            <LinkRedirect path="/kindred-faqs" />
          </Route>
          <Route path={Path.Network} exact>
            <LinkRedirect />
          </Route>
          <Route path={Path.AboutUs} exact>
            <LinkRedirect path="/about-us" />
          </Route>
          <Route path={Path.Loyalty} exact>
            <LinkRedirect />
          </Route>
          <Route path={Path.Revenue} exact>
            <LinkRedirect />
          </Route>
          <Route path={Path.ESG} exact>
            <LinkRedirect />
          </Route>
          <Route path={Path.ProductHome} exact>
            <LinkRedirect />
          </Route>
          <Route path={Path.ProductExtension} exact>
            <LinkRedirect />
          </Route>
          <Route path={Path.Gaming} exact>
            <LinkRedirect />
          </Route>
          <Route path={Path.ProductDesktop} exact>
            <LinkRedirect />
          </Route>
          <Route path={Path.ProductApi} exact>
            <LinkRedirect />
          </Route>
          <Route path={Path.ChromeExtensionDownload} exact>
            <ChromeDesktopUTMTracking />
          </Route>
          <Redirect from={Path.MobileGame} to={Path.Gaming} />
          <Redirect from={Path.CharitiesWithAnApp} to={Path.ESG} />
          <Redirect from={Path.Cashback} to={Path.Revenue} />
          <Redirect from={Path.MobileApp} to={Path.Home} />
          <Redirect from={Path.MobileNetwork} to={Path.Home} />
          <Redirect from={Path.Keyboard} to={Path.ProductHome} />

          <Route>
            <NotFound />
          </Route>
        </Switch>
      </DefaultLayout>
    </Switch>
  </Suspense>
);

export default Routes;
